// extracted by mini-css-extract-plugin
export default {"root":"styles_root__49UeQ","container":"styles_container__jrebj","title":"styles_title__QfJTk","content":"styles_content__mJubX","clickable":"styles_clickable__zUoMc"};